import React from 'react';
import Login from '@pages/Login';
import UserManagement from '@pages/UserManagement';
import AddEditUserManagment from '@pages/UserManagement/components/addEdit';
import UploadSellout from '@pages/UploadSellout';
import BusinessSiso from '@pages/BusinessSiso';
import StoreConfig from '@pages/StoreConfig';
import ForbiddenPage from '@pages/Forbidden';
import StockTrail from '@pages/StockTrail';
import ResetPassword from '@pages/ResetPassword';
import StoreConfigDetail from '@pages/StoreConfig/sections/detail';
import Profile from '@pages/Profile';
import Achievement from '@pages/Achievement';
import {
    AuditIcon,
    DashboardIcon,
    OrderIcon,
    StoreIcon,
    UploadIcon,
    UserManagementIcon,
    PercentageIcon,
} from './icons';
import OauthPage from '@pages/Oauth';
import Documentation from '@pages/Documentation';
import StoreConfigurationDetail from '@pages/storeConfigurationDetail';
import AuditTrailParahub from '@pages/AuditTrailParahub';
import Parahub from '@pages/Parahub';
import ParahubDetail from '@pages/Parahub/components/detail';
import ConsumerPromotion from '@pages/ConsumerPromotion';
import DetailPromotion from '@pages/ConsumerPromotion/components/Detail';
import DetailCustomer from '@pages/ConsumerPromotion/components/Detail/EditCustomer/DetailCustomer';
import UploadMappingV2 from '@pages/UploadMappingV2';
import AllMapping from '@pages/UploadMappingV2/modules/ProductMapping/AllMapping';
import Mapping from '@pages/UploadMappingV2/modules/UploadProduct/Massal/Mapping';
import Konversi from '@pages/UploadSellout/sections/konversi';
import { AppProvider } from '@pages/UploadMappingV2/context/AppContext';
import AuditTrailSellOut from '@pages/AuditTrailSellOut';
import SelloutMonitoring from '@pages/SelloutMonitoring';

export const routeList = [
    {
        path: '/login',
        element: <Login />,
        name: 'Login',
        id: 'login',
        showInSideBar: false,
    },
    {
        path: '/oauth',
        element: <OauthPage />,
        name: 'oauth',
        id: 'oauth',
        showInSideBar: false,
    },
    {
        path: '/upload-sellout',
        icon: <UploadIcon />,
        name: 'Upload',
        showInSideBar: true,
        children: [
            {
                path: '/upload-sellout',
                id: 'upload_data',
                name: 'Sellout',
                element: <UploadSellout />,
            },
            {
                path: '/upload-mapping-v2',
                id: 'upload_data',
                name: 'Mapping',
                element: (
                    <AppProvider>
                        <UploadMappingV2 />
                    </AppProvider>
                ),
            },
        ],
    },
    {
        id: 'upload_data',
        path: '/upload-mapping-v2/all-mapping',
        name: 'List Produk',
        element: (
            <AppProvider>
                <AllMapping />
            </AppProvider>
        ),
        showInSideBar: false,
    },
    {
        id: 'upload_data',
        path: '/upload-mapping-v2/mapping-product',
        name: 'Mapping Produk',
        element: (
            <AppProvider>
                <Mapping />
            </AppProvider>
        ),
        showInSideBar: false,
    },

    {
        id: 'upload_data',
        path: '/upload-sellout/konversi',
        name: 'Konversi',
        element: <Konversi />,
        showInSideBar: false,
    },
    {
        path: '/order-management/create',
        icon: <OrderIcon />,
        name: 'Order Management',
        showInSideBar: true,
        children: [
            {
                path: '/order-management/create',
                element: <ForbiddenPage />,
                name: 'Create',
                id: 'order_management',
            },
            {
                path: '/order-management/active-order',
                element: <ForbiddenPage />,
                name: 'Active Order',
                id: 'order_management',
            },
            {
                path: '/order-management/history',
                element: <ForbiddenPage />,
                name: 'History',
                id: 'order_management',
            },
        ],
    },
    {
        path: '/audit-trail',
        icon: <AuditIcon />,
        name: 'Audit Trail',
        showInSideBar: true,
        children: [
            {
                path: '/audit-trail/parahub',
                id: 'parahub',
                showInSideBar: true,
                name: 'Sell Out - Parahub ',
                element: <AuditTrailParahub />,
            },
            {
                path: '/audit-trail/sell-out',
                id: 'audit_trail',
                showInSideBar: true,
                name: 'Sell Out ',
                element: <AuditTrailSellOut />,
            },

            {
                path: '/stock-trail',
                id: 'audit_trail',
                element: <StockTrail />,
                name: 'Stock',
            },
        ],
    },
    {
        id: 'promotion-claim',
        path: '/consumer-promotion',
        icon: <PercentageIcon />,
        name: 'Consumer Promotion',
        element: <ConsumerPromotion />,
        showInSideBar: true,
    },
    {
        id: 'promotion-claim',
        path: '/consumer-promotion/detail/:id',
        name: 'Consumer Promotion Detail',
        element: <DetailPromotion />,
        showInSideBar: false,
    },
    {
        id: 'promotion-claim',
        path: '/consumer-promotion/detail/:id/customer/:customerId',
        name: 'Consumer Promotion Detail - Detail Customer',
        element: <DetailCustomer />,
        showInSideBar: false,
    },
    {
        path: '/business-siso',
        icon: <DashboardIcon />,
        name: 'Dashboard',
        showInSideBar: true,
        children: [
            {
                path: '/business-siso',
                id: 'siso_dashboard',
                name: 'Business SiSo',
                element: <BusinessSiso />,
            },
            {
                path: '/dashboard',
                id: 'dashboard',
                element: <Achievement />,
                name: 'Pencapaian',
            },
            {
                path: '/sellout-monitoring',
                id: 'dashboard_monitoring_sellout',
                element: <SelloutMonitoring />,
                name: 'Sellout Monitoring',
            },
        ],
    },
    {
        path: '/store-config/iseller',
        icon: <StoreIcon />,
        name: 'Store Configuration',
        showInSideBar: true,
        children: [
            {
                path: '/store-config/iseller',
                name: 'Integration',
                element: <StoreConfig />,
                id: 'configuration_store',
            },
            {
                path: '/store-config/parahub',
                name: 'Parahub',
                element: <Parahub />,
                id: 'parahub',
            },
        ],
    },
    {
        path: '/store-config/parahub/:id',
        id: 'parahub',
        name: 'Parahub Detail',
        element: <ParahubDetail />,
        showInSideBar: false,
    },
    {
        path: '/store-config/iseller/:id',
        id: 'configuration_store',
        name: 'Store Config',
        element: <StoreConfigurationDetail />,
        showInSideBar: false,
    },
    {
        path: '/store-configuration/iseller/:id',
        id: 'configuration_store',
        name: 'Store Config',
        element: <StoreConfigDetail />,
        showInSideBar: false,
    },
    {
        path: '/profile',
        id: 'profile',
        name: 'Profile',
        element: <Profile />,
        type: '*',
        showInSideBar: false,
    },
    {
        path: '/user-management',
        icon: <UserManagementIcon />,
        name: 'User Management',
        element: <UserManagement />,
        id: 'user_management',
        showInSideBar: true,
    },
    {
        path: '/user-management/create',
        id: 'user_management',
        name: 'User Management',
        element: <AddEditUserManagment />,
        showInSideBar: false,
    },

    {
        path: '/user-management/edit/:id/:uniqueEmail',
        id: 'user_management',
        name: 'User Management',
        element: <AddEditUserManagment />,
        showInSideBar: false,
    },
    {
        path: '/documentation',
        element: <Documentation />,
        type: '*',
        name: 'Documentation',
        showInSideBar: false,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        type: '*',
        name: 'Reset password',
        showInSideBar: false,
    },

    {
        path: '*',
        type: '*',
        element: <ForbiddenPage />,
        showInSideBar: false,
    },
];

const routeListMappingHandler = (routes) => {
    const arr = [];
    const routeListTemp = [...routes];

    //================ PUSH CHILDREN TO ROUTES ===========================

    routeListTemp?.forEach((route) => {
        route.children ? route.children.forEach((item) => arr.push(item)) : arr.push(route);
    });

    return arr;
};

export const routes = routeListMappingHandler(routeList);

export default routes;
